module.exports = __webpack_public_path__ + "static/img/子拓logo@3x.836fc62.png";


//////////////////
// WEBPACK FOOTER
// ./img/首页/子拓logo@3x.png
// module id = XlWu
// module chunks = 1